import { sb } from "../supabase.js";

const logActivity = (uid, kind, type, id, summary, payload) =>
    sb
      .from("activity")
      .insert({
        actor_id: uid,
        kind,
        entity_type: type,
        entity_id: id,
        summary,
        payload,
      })
      .then(
        () => {},
        () => {},
      );

export { logActivity };
